import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FeaturesSection } from './components/FeaturesSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { OrderFormModal } from './components/OrderFormModal';
import { HowItWorksModal } from './components/HowItWorksModal';
import { ContactModal } from './components/ContactModal';
export function App() {
  const [isOrderOpen, setIsOrderOpen] = useState(false);
  const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  return <div className="min-h-screen bg-brown-800 text-white font-sans selection:bg-accent-pink selection:text-white overflow-x-hidden" data-id="element-0">
      <Navbar onDemoClick={() => setIsOrderOpen(true)} onHowItWorksClick={() => setIsHowItWorksOpen(true)} data-id="element-1" />
      <main data-id="element-2">
        <HeroSection onOrderClick={() => setIsOrderOpen(true)} onHowItWorksClick={() => setIsHowItWorksOpen(true)} data-id="element-3" />
        <HowItWorksSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <ComparisonSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <FAQSection data-id="element-8" />
        <CTASection onOrderClick={() => setIsOrderOpen(true)} data-id="element-9" />
      </main>
      <Footer onHowItWorksClick={() => setIsHowItWorksOpen(true)} onContactClick={() => setIsContactOpen(true)} data-id="element-10" />
      <OrderFormModal isOpen={isOrderOpen} onClose={() => setIsOrderOpen(false)} data-id="element-11" />
      <HowItWorksModal isOpen={isHowItWorksOpen} onClose={() => setIsHowItWorksOpen(false)} data-id="element-12" />
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} data-id="element-13" />
    </div>;
}